import { Controller } from "@hotwired/stimulus";

// Copies text to the clipboard. Give it either a `text` value holding the text
// itself, or a `source` action param holding the id of the element to read from.
export default class extends Controller {
  static values = { text: String };

  disconnect() {
    clearTimeout(this.resetTimer);
  }

  copy({ params: { source } }) {
    const text = source ? this.textFrom(source) : this.textValue;

    this.write(text)
      .then(() => this.flash("Copied"))
      .catch(() => {
        this.selectInstead(source);
        this.flash("Press Ctrl+C");
      });
  }

  // navigator.clipboard exists only in a secure context, which excludes the plain
  // http dev host, so treat its absence as a rejection and fall back to selecting.
  write(text) {
    if (!navigator.clipboard) return Promise.reject(new Error("clipboard unavailable"));

    return navigator.clipboard.writeText(text);
  }

  // Selects the source text so the user can copy it by hand when the clipboard
  // API is unavailable or the write was denied.
  selectInstead(source) {
    const element = source && document.getElementById(source);
    if (!element) return;

    const range = document.createRange();
    range.selectNodeContents(element);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  textFrom(id) {
    const element = document.getElementById(id);

    return element ? element.textContent : "";
  }

  // The label is captured once and any pending timer is cleared, so repeated
  // clicks cannot leave the button stuck showing the confirmation text.
  flash(message) {
    this.originalLabel = this.originalLabel || this.element.textContent;
    clearTimeout(this.resetTimer);

    this.element.textContent = message;
    this.resetTimer = setTimeout(() => { this.element.textContent = this.originalLabel; }, 2000);
  }
}
